import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';
import ZonesList from '../pages/zones/ZonesList';

const ZoneRoutes: React.FC = () => {
  return (
    <Routes>
      <Route 
        path="/" 
        element={
          <ProtectedRoute>
            <ZonesList />
          </ProtectedRoute>
        } 
      />
    </Routes>
  );
};

export default ZoneRoutes;
